// extracted by mini-css-extract-plugin
export default {"button":"single-video_button__7cRe5"};